/* import __COLOCATED_TEMPLATE__ from './user-search-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-default-task-ember-concurrency */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Resource, type Named } from 'ember-resources';
import { useResource } from 'ember-resources';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import { taskFor } from 'ember-concurrency-ts';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import type InboxSearchSuggestionsService from 'embercom/services/inbox-search-suggestions-service';
import { type SearchDropdownArgs, type SearchDropdownSignature } from './search-dropdown';

interface UserSearchResourceArgs {
  searchTerm: string;
}

class UserSearchResource extends Resource<Named<UserSearchResourceArgs>> {
  @service declare inboxSearchSuggestionsService: InboxSearchSuggestionsService;
  @tracked results: Array<any> = [];

  searchTerm: string;

  get isLoading() {
    return taskFor(this.search).isRunning;
  }

  constructor(owner: any, args: Named<UserSearchResourceArgs>, previous: UserSearchResource) {
    super(owner, args, previous);

    this.searchTerm = args.named.searchTerm;

    taskFor(this.search).perform(args.named.searchTerm);
  }

  @task *search(searchTerm: string) {
    this.results = [];

    let users: UserSummary[] = yield this.inboxSearchSuggestionsService.getUserSuggestions(
      searchTerm,
      10,
      [],
      'contains',
    );

    this.results = users;
  }
}

type Args<T> = Pick<
  SearchDropdownArgs<T>,
  | 'onEscape'
  | 'searchPlaceholder'
  | 'popoverPlacement'
  | 'fallbackPopoverPlacements'
  | 'onPopoverShow'
  | 'onPopoverHide'
  | 'initiallyOpen'
  | 'size'
>;

interface Signature<T> {
  Element: HTMLDivElement;
  Args: Args<T>;
  Blocks: {
    opener: [];
    placeholder: [];
    dataRow: SearchDropdownSignature<T>['Blocks']['dataRow'];
    footer: SearchDropdownSignature<T>['Blocks']['footer'];
  };
}

export default class UserSearchDropdown<T> extends Component<Signature<T>> {
  @tracked query = '';

  @tracked userSearchData = useResource(this, UserSearchResource, () => ({
    searchTerm: this.query,
  }));

  @action onQueryChanged(query: string) {
    this.query = query;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::UserSearchDropdown': typeof UserSearchDropdown;
    'inbox2/common/user-search-dropdown': typeof UserSearchDropdown;
  }
}
